import { useQuery, useQueryClient } from "@tanstack/react-query";

import { InvitationListRequest } from "@nens/rana/api-v1";
import { getRanaApiV1 } from "@nens/rana/api-v1";

import { createItemUpdaterForQueryLists } from "./hooks/create-item-updater-for-query-list";

// Single

const getInvitedUserListQuery = (params: Omit<InvitationListRequest, "tenantId">) => {
  return getRanaApiV1().getQueryOptions({
    queryKey: ["project-users", "list", params],
    queryFn: async () => getRanaApiV1().InvitationsApi.invitationList(params),
  });
};

export const useInvitedUserListQuery = (params: Omit<InvitationListRequest, "tenantId">) => {
  return useQuery(getInvitedUserListQuery(params));
};

// INVALIDATION

export const useInvalidateInvitedUserListQuery = () => {
  const queryClient = useQueryClient();
  return async () => {
    await queryClient.invalidateQueries({
      queryKey: getInvitedUserListQuery({}).queryKey.slice(0, -1),
      refetchType: "all",
    });
  };
};

export const useUpdateInvitedUserListQuery = () => {
  const queryClient = useQueryClient();
  return createItemUpdaterForQueryLists(queryClient, {
    getQueryKey: () => getInvitedUserListQuery({}).queryKey.slice(0, -1),
  });
};
